export const messages = {
  title: 'Campaigns',
};
